import { usePathname } from "expo-router";
import { StyleSheet, useWindowDimensions, View } from "react-native";
import { Drawer } from "expo-router/drawer";
import { useState, useEffect } from "react";

import { ChatDrawerHeader } from "@/components/Chat/ChatDrawerHeader";
import { SMSDrawerContent } from "@/components/Chat/SMSDrawerContent";

function ChatLayoutContent() {
  const windowDimensions = useWindowDimensions();
  const pathname = usePathname();

  const [searchValue, setSearchValue] = useState("");
  const [smsPhoneNumber, setSmsPhoneNumber] = useState<string | null>(null);

  // Extract phone number from SMS path
  useEffect(() => {
    if (pathname.startsWith("/chat/sms/")) {
      const match = pathname.match(/\/chat\/sms\/([^/]+)/);
      if (match) {
        setSmsPhoneNumber(decodeURIComponent(match[1]));
        return;
      }
    }
    setSmsPhoneNumber(null);
  }, [pathname]);

  const handleModeChange = (mode: "chat" | "sms", phoneNumber?: string) => {
    if (mode === "sms" && phoneNumber) {
      setSmsPhoneNumber(phoneNumber);
    } else {
      setSmsPhoneNumber(null);
    }
  };

  const drawerType = windowDimensions.width < 900 ? "front" : "permanent";

  const renderDrawerContent = () => {
    return (
      <View style={styles.drawerContent}>
        <ChatDrawerHeader searchValue={searchValue} setSearchValue={setSearchValue} onModeChange={handleModeChange} />
        {smsPhoneNumber && <SMSDrawerContent phoneNumber={smsPhoneNumber} />}
      </View>
    );
  };

  return (
    <Drawer
      screenOptions={{
        drawerType,
        headerLeft: windowDimensions.width >= 900 ? () => null : undefined,
      }}
      drawerContent={renderDrawerContent}
    >
      <Drawer.Screen name="index" options={{ headerShown: true, title: "Chat" }} />
      <Drawer.Screen
        name="sms/[phone]"
        options={{
          headerShown: false,
        }}
      />
    </Drawer>
  );
}

export default function ChatLayout() {
  return <ChatLayoutContent />;
}

const styles = StyleSheet.create({
  drawerContent: {
    flex: 1,
  },
});
